import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Regions';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Regions extends RpcClass{

    /**
     *  @class Regions
     *  @alias module:src/server/com/silkplm/rpc/Regions.Regions
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param _translations {Object.<string, *>} 
     * @param fieldName {string} 
     * @param clazz {string} 
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     assignTranslations(_translations, fieldName, clazz, id) {
            return RpcClass.rpcCall('/rpc/regions/assign-translations', [_translations, fieldName, clazz, id]);
    }
    /** 
     * @async
     * @param basePrice {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency>>}
     */
     computePricesForRegions(basePrice) {
            return RpcClass.rpcCall('/rpc/regions/compute-prices-for-regions', [basePrice]);
    }
    /** 
     * @async
     * @param text {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/translations/DetectResult.DetectResult>}
     */
     detectLang(text) {
            return RpcClass.rpcCall('/rpc/regions/detect-lang', [text]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/RegionsConfig.RegionsConfig>}
     */
     loadRegionsConfig() {
            return RpcClass.rpcCall('/rpc/regions/load-regions-config', []);
    }
    /** 
     * @async
     * @param fromLang {string} 
     * @param toLang {string} 
     * @param text {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     translate(fromLang, toLang, text) {
            return RpcClass.rpcCall('/rpc/regions/translate', [fromLang, toLang, text]);
    }
    /** 
     * @async
     * @param fromLang {string} 
     * @param toLangList {string[]} 
     * @param text {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, string>>}
     */
     translateToMultiLang(fromLang, toLangList, text) {
            return RpcClass.rpcCall('/rpc/regions/translate-to-multi-lang', [fromLang, toLangList, text]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Regions';
metadata.__type_short__ = 'Regions';
Regions.prototype.__metadata__ = metadata;

Regions.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Regions */
export default Regions

export { Regions }
